import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
	MATCH_VISIBLE,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE, TYPE_DEFAULT_VALUE, TYPE_WORKFLOW_COMPONENT_OBSERVER, EXPRESSION_FIELD_SCOPE, FONCTION_WORKFLOW_COMPONENT_OPTIONS } from 'src/app/app.models';
import { COMPONENT_MODE, COMPONENT_UI } from '../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../workflow-components.service';
  
export interface LabelModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
}
  
export class LabelModel extends DynamicInputModel {
	@serializable() readonly type: string = 'label'; 
	componentMode: COMPONENT_MODE;
	componentUI: COMPONENT_UI;

	constructor(config: LabelModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
		this.componentUI = COMPONENT_UI.IONIC;
	}

	static initModel(_component: Model_WorkflowComponent): LabelModel {
		const formModel = new LabelModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
			additional: _component,
			relations: _component.RELATIONS
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
        const timestamp = (Math.floor(Date.now() / 1000) + "");
		return {
			ID: 'label',
			CODE: CODE_WORKFLOW_COMPONENT.LABEL,
			ICON: 'chatbox-ellipses-outline',
			LABEL: 'Label',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', DEFAULT_VALUE: 'LABEL_' + timestamp, IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTAREA, LABEL: 'Contenu (HTML support)', IS_REQUIRED: true },
			]
		};
	}
}
  